import { useState, useEffect, useRef } from "react";
import {
  KeyboardAvoidingView,
  StyleSheet,
  RefreshControl,
  Keyboard,
  ScrollView,
  View,
} from "react-native";
import { web, android, ios } from "./Platform";
import { Animated } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

const useKeyboardStatus = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const showSubscription = Keyboard.addListener("keyboardWillShow", () => {
      setEnabled(true);
    });
    const hideSubscription = Keyboard.addListener("keyboardWillHide", () => {
      setEnabled(false);
    });
    const keyboardDidShow = Keyboard.addListener("keyboardDidShow", () => {
      setEnabled(false);
    });

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
      keyboardDidShow.remove();
    };
  }, []);

  return enabled;
};

const ScrollContainer = (props) => {
  const {
    children,
    scrollToTop = false,
    setScrollToTop = () => {},
    pullDownRefresh = false,
    onScroll = () => {},
    showScrollBar = false,
  } = props;

  const scrollViewRef = useRef(null);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    if (scrollToTop && !web) {
      setScrollToTop(false);
      if (scrollToTop === 999) {
        setTimeout(() => {
          scrollViewRef.current.scrollToEnd({ animated: true });
        }, 0);
      } else {
        try {
          scrollViewRef.current.scrollToOffset({ offset: 0, animated: true });
        } catch (error) {
          scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true });
        }
      }
    } else if (scrollToTop && web) {
      setScrollToTop(false);

      try {
        if (scrollToTop === 999) {
          setTimeout(() => {
            document.querySelector(
              'div[data-testid="scrollContainer"]'
            ).scrollTop = document.querySelector(
              'div[data-testid="scrollContainer"]'
            ).scrollHeight;
          }, 0);
        } else {
          document
            .querySelector('div[data-testid="scrollContainer"]')
            .scrollTo({
              top: 0,
              behavior: "smooth",
            });
        }
      } catch (error) {}
    }
  }, [props]);

  const onRefresh = async () => {
    if (pullDownRefresh) {
      setRefreshing(true);
      await pullDownRefresh();
      setRefreshing(false);
    }
  };

  const [keyboardVerticalOffset, setKeyboardVerticalOffset] = useState(0),
    viewRef = useRef(null),
    onLayout = (event) => {
      if (viewRef.current) {
        viewRef.current.measure((x, y, width, height, pageX, pageY) => {
          if (keyboardVerticalOffset !== pageY) {
            setKeyboardVerticalOffset(pageY + 20);
          }
        });
      }
    };

  return (
    <>
      {ios ? (
        <View ref={viewRef} onLayout={onLayout}>
          <KeyboardAvoidingView
            behavior="padding"
            keyboardVerticalOffset={keyboardVerticalOffset || 30}
            keyboardShouldPersistTaps="handled"
            showsVerticalScrollIndicator={false}
            enabled={useKeyboardStatus() || false}
            showsHorizontalScrollIndicator={false}
            style={{
              flexGrow: 1,
              flexShrink: 1,
            }}
          >
            <Animated.ScrollView
              scrollEventThrottle={16}
              onScroll={onScroll}
              refreshControl={
                pullDownRefresh && (
                  <RefreshControl
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                  />
                )
              }
              ref={scrollViewRef}
              showsVerticalScrollIndicator={false}
              showsHorizontalScrollIndicator={false}
              keyboardShouldPersistTaps="handled"
              alwaysBounceVertical={!true}
              contentContainerStyle={[styles.scrollContent]}
            >
              {children}
            </Animated.ScrollView>
          </KeyboardAvoidingView>
        </View>
      ) : android ? (
        <>
          <KeyboardAvoidingView
            behavior={null}
            keyboardVerticalOffset={0}
            keyboardShouldPersistTaps="handled"
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
          >
            <Animated.ScrollView
              refreshControl={
                pullDownRefresh && (
                  <RefreshControl
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                  />
                )
              }
              ref={scrollViewRef}
              onScroll={onScroll}
              contentContainerStyle={[
                styles.scrollContent,
                // {
                //   paddingBottom:
                //     (keyBoardEnabled ? keyboardDetails["height"] || 300 : 0) +
                //     (android ? 90 : 0),
                // },
              ]}
              keyboardShouldPersistTaps="handled"
              showsVerticalScrollIndicator={false}
              showsHorizontalScrollIndicator={false}
              alwaysBounceVertical={!true}
            >
              {children}
            </Animated.ScrollView>
          </KeyboardAvoidingView>
        </>
      ) : (
        <>
          <KeyboardAwareScrollView
            keyboardShouldPersistTaps="handled"
            refreshControl={
              pullDownRefresh && (
                <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
              )
            }
            showsVerticalScrollIndicator={showScrollBar}
            // showsHorizontalScrollIndicator={false}
            style={props["style"] || {}}
          >
            <KeyboardAvoidingView behavior={null} keyboardVerticalOffset={0}>
              <ScrollView
                ref={scrollViewRef}
                contentContainerStyle={[styles.scrollContent]}
                keyboardShouldPersistTaps="handled"
                showsVerticalScrollIndicator={showScrollBar}
                // showsHorizontalScrollIndicator={showScrollBar}
                alwaysBounceVertical={!true}
              >
                {children}
              </ScrollView>
            </KeyboardAvoidingView>
          </KeyboardAwareScrollView>
        </>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  body: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: android ? 90 : 0,
  },
});

export default ScrollContainer;
